import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

// update site header [title tag] when route is changed
const AppTitle = ({ intl, routeTitle = '' }) =>
  intl && intl.formatMessage ? (
    <Helmet>
      <title>
        {routeTitle
          ? `${intl.formatMessage({ id: routeTitle, defaultMessage: routeTitle })}`
          : `${intl.formatMessage({ id: 'app.name', defaultMessage: 'PDSC' })}`}
      </title>
    </Helmet>
  ) : null;

AppTitle.propTypes = {
  intl: PropTypes.object,
  routeTitle: PropTypes.string
};

export default React.memo(props => <AppTitle {...props} />);
